import { ApplicationState } from './../../types';

export const selectSemrushIsError = ({ semrush }: ApplicationState) => semrush.isError;

export const selectSemrushIsPending = ({ semrush }: ApplicationState) => semrush.isPending;